"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartnerParamComponent = void 0;
const core_1 = require("@angular/core");
const demand_partner_1 = require("./demand-partner");
let DemandPartnerParamComponent = class DemandPartnerParamComponent {
    constructor() {
        this.userHover = false;
        this.expanded = false;
        this.field = new demand_partner_1.DemandPartnerField;
    }
    isItRequired(req) {
        if (req) {
            return "";
        }
        else {
            return "(optional)";
        }
    }
};
exports.DemandPartnerParamComponent = DemandPartnerParamComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", demand_partner_1.DemandPartnerField)
], DemandPartnerParamComponent.prototype, "field", void 0);
exports.DemandPartnerParamComponent = DemandPartnerParamComponent = __decorate([
    (0, core_1.Component)({
        selector: 'myDemandPartnerParam',
        template: `
		<label>{{field.name}} {{isItRequired(field.required)}}:</label>
		<input type="text" class="form-control ourInput demandPartnerField" placeholder="{{field.name}}" [(ngModel)]="field.value">
  `
    })
], DemandPartnerParamComponent);
//# sourceMappingURL=demand-partner-param.component.js.map